// Occurrence identity belongs in a shareable path, independently of calendar navigation state.
export function eventDetailUrl(path: string, occurrence?: string | null): string {
  return occurrence ? `${path.replace(/\/$/, '')}/on/${encodeURIComponent(occurrence)}` : path;
}
export function parseEventDetailPath(path: string): { path: string; occurrence: string | null } {
  const match = /^(\/events\/\d{4}\/\d{1,2}\/[a-z0-9-]+)\/on\/([^/]+)\/?$/.exec(path);
  if (!match) return { path, occurrence: null };
  try {
    return { path: match[1]!, occurrence: decodeURIComponent(match[2]!) };
  } catch {
    return { path, occurrence: null };
  }
}
